/* Galaxy homepage card carousel (2026-08-19).
   Progressive enhancement: the Liquid renders a plain .cards grid, which is
   what no-JS / pre-hydration users see. This script wraps it, adds .gcar and
   turns it into a scroll-snap track with arrows.
   Opt in per section with data-gcar on the .cards div -- do NOT widen the
   selector to bare .cards, galaxy-home-1/2 snippets use that class too. */
(function () {
  if (window.__gcar) return;
  window.__gcar = 1;

  function setup(track) {
    if (track.dataset.gcarReady) return;
    track.dataset.gcarReady = '1';
    track.classList.add('gcar');

    var wrap = document.createElement('div');
    wrap.className = 'gcar-wrap';
    track.parentNode.insertBefore(wrap, track);
    wrap.appendChild(track);

    /* Park the arrows in the section header next to the Shop all link rather
       than floating them over the track: the .wrap gutter is only ~30px wide,
       so outboard arrows get clipped, and inboard ones cover the product photo.
       Falls back to overlaying the track if a section ever lacks a header. */
    var head = null;
    var block = track.closest('.blk');
    if (block) head = block.querySelector('.sec-head');
    var bar = null;
    if (head) {
      bar = document.createElement('div');
      bar.className = 'gcar-navs';
      head.appendChild(bar);
    } else {
      wrap.classList.add('gcar-overlay');
    }

    function arrow(dir, label) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'gcar-nav gcar-' + dir;
      b.setAttribute('aria-label', label);
      (bar || wrap).appendChild(b);
      return b;
    }
    var prev = arrow('prev', 'Show previous products');
    var next = arrow('next', 'Show more products');

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var over = max > 4;
      wrap.classList.toggle('gcar-has-nav', over);
      if (bar) bar.classList.toggle('gcar-has-nav', over);
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft >= max - 4;
    }
    /* Native smooth scrolling is broken on this track: both
       scrollBy({behavior:smooth}) and CSS scroll-behavior:smooth animate to
       nowhere and leave scrollLeft at 0 (verified in Chrome on the Final
       preview, 2026-08-19). Instant jumps work fine, so tween scrollLeft
       ourselves. Do NOT reintroduce scroll-behavior:smooth in the CSS. */
    var anim = null;
    function page(sign) {
      var max = track.scrollWidth - track.clientWidth;
      var from = track.scrollLeft;
      var to = Math.max(0, Math.min(max, from + sign * track.clientWidth));
      if (to === from) return;
      if (anim) cancelAnimationFrame(anim);
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        track.scrollLeft = to;
        update();
        return;
      }
      var t0 = performance.now();
      var dur = 380;
      /* rAF is throttled in background tabs, which would leave the track
         mid-tween; land it regardless once the animation window is over. */
      setTimeout(function () {
        if (anim) { cancelAnimationFrame(anim); anim = null; }
        if (Math.abs(track.scrollLeft - to) > 2) track.scrollLeft = to;
        update();
      }, dur + 120);
      (function step(now) {
        var p = Math.min(1, (now - t0) / dur);
        var e = 1 - Math.pow(1 - p, 3);
        track.scrollLeft = from + (to - from) * e;
        if (p < 1) anim = requestAnimationFrame(step);
        else { anim = null; update(); }
      })(t0);
    }
    prev.addEventListener('click', function () { page(-1); });
    next.addEventListener('click', function () { page(1); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    /* Images are lazy and unsized until they decode, so scrollWidth is wrong
       on first paint -- re-measure after load as well as immediately. */
    window.addEventListener('load', update);
    update();
  }

  function init() {
    var tracks = document.querySelectorAll('[data-gcar]');
    for (var i = 0; i < tracks.length; i++) setup(tracks[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* Theme editor re-renders a section without a page load. */
  document.addEventListener('shopify:section:load', init);
})();
